"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaTags = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var _gatsby = require("gatsby");

var _utils = require("../../utils");

var _hooks = require("../../hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MetaTags = function MetaTags(_ref) {
  var page = _ref.page,
      title = _ref.title,
      description = _ref.description;
  var theme = (0, _hooks.useTheme)();

  var _useLocale = (0, _hooks.useLocale)(),
      locale = _useLocale.locale;

  var companyName = (0, _utils.getProperty)(theme, "meta.company");
  var pageLabel = (0, _utils.getProperty)(theme, "meta.page");
  var pageText = "".concat(pageLabel, " ").concat(page);
  var metaDescription = description;
  var metaTitle = (0, _react.useMemo)(function () {
    var titles = [title];

    if (page > 1) {
      titles.push(pageText);
    }

    titles.push(companyName);
    return titles.join(" | ");
  }, [title, page, pageText, companyName]);
  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("html", {
    lang: locale
  }), /*#__PURE__*/_react.default.createElement("title", null, metaTitle), /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: "index, follow"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: metaDescription
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "og:locale",
    content: locale
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "og:type",
    content: "website"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "og:title",
    content: metaTitle
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "og:description",
    content: metaDescription
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:title",
    content: metaTitle
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:description",
    content: metaDescription
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "format-detection",
    content: "telephone=no"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: (0, _gatsby.withPrefix)("/apple-touch-icon.png")
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: (0, _gatsby.withPrefix)("/favicon-32x32.png")
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: (0, _gatsby.withPrefix)("/favicon-16x16.png")
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "manifest",
    href: (0, _gatsby.withPrefix)("/site.webmanifest")
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "mask-icon",
    href: (0, _gatsby.withPrefix)("/safari-pinned-tab.svg"),
    color: "#00a3a6"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "msapplication-TileColor",
    content: "#000000"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "theme-color",
    content: "#000000"
  }));
};

exports.MetaTags = MetaTags;
MetaTags.defaultProps = {
  page: 1
};
MetaTags.propTypes = {
  page: _propTypes.default.number,
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired
};